import axios from 'axios';

// Detect backend URL based on hostname
const getBackendUrl = () => {
  // If env variable is set, use it
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // Production: map frontend domain to backend domain
  const hostname = window.location.hostname;
  
  // Custom domain mapping
  // v5.4.20 — Prefer api.cminventario.com when DNS is configured; fall back
  // to the Railway service URL during the transition window.
  if (hostname === 'cminventario.com' || hostname === 'www.cminventario.com') {
    return 'https://api.cminventario.com';
  }
  
  // Railway preview domain
  if (hostname.includes('railway.app')) {
    // Assume backend is on a sibling service
    return `https://${hostname.replace('frontend', 'backend')}`;
  }
  
  // Local development or fallback
  return '';
};

const API_URL = getBackendUrl();

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
